import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { getCompany, getLoadingStatus, getSavingStatus } from '../../../../redux/company/selectors';
import { companyActions } from '../../../../redux/company/actions';

export const useCompanyData = () => {
  const { myCompanyId } = useParams();
  const dispatch = useDispatch();
  const companyData = useSelector(getCompany);
  const loading = useSelector(getLoadingStatus);
  const saving = useSelector(getSavingStatus);

  useEffect(() => {
    if (!myCompanyId) return;

    dispatch(companyActions.loadCompany(myCompanyId));
  }, [dispatch, myCompanyId]);

  return { companyData, loading, saving };
};
